import React from 'react';
import styled from 'styled-components';

import { Container } from '../';

const EchoImg = styled.div`
  height: 350px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  top: -90px;
  height: 170px;
`;

// eslint-disable-next-line react/display-name
export default () => (
  <Container fluid mt={{ xs: 12, md: 6 }} style={{ borderTop: '1px solid #D9DADA' }}>
    <a name="get-started" />
    <EchoImg>
      <img src="https://assets.homeimprovementpages.com.au/images/alexa/amazon-echo.png" />
    </EchoImg>
  </Container>
);
